import { NgModule } from '@angular/core';
import { VerifyPatientRegistrationRoutesModule } from './verify-patient-registration.routes';
import { VerifyPatientRegistrationComponent } from './verify-patient-registration.component';
import { BaseModule } from '../shared/base.module';
import { MATERIALS } from '../app.materials';
import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        VerifyPatientRegistrationRoutesModule,
        MyDatePickerModule
    ],
    declarations: [
        VerifyPatientRegistrationComponent
    ]
})
export class VerifyPatientRegistrationModule { }
